module.exports = __webpack_public_path__ + "static/img/progress-th.4234d2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/progress/progress-th.png
// module id = wrIt
// module chunks = 1